import { ApiError } from "@/lib/apiClient";
import {
  createProjectFotoSession,
  uploadProjectFotoFile,
  type ProjectFotoSession,
} from "@/lib/projectOverview";

const PHOTO_EXTENSIONS = /\.(png|jpe?g|webp|gif|heic|heif|pdf)$/i;

export function filesForProjectFotos(list: FileList | File[] | null | undefined): File[] {
  if (!list?.length) return [];
  return Array.from(list).filter((file) => {
    const type = (file.type || "").toLowerCase();
    if (type.startsWith("image/") || type === "application/pdf") return true;
    return PHOTO_EXTENSIONS.test(file.name);
  });
}

/** Legt Fotos im neuesten Ordner ab, oder legt „Fotos“ an, wenn noch keiner existiert. */
export async function uploadDroppedProjectFotos(
  orderId: number,
  files: File[],
  sessions: ProjectFotoSession[],
): Promise<{ count: number; folderTitle: string }> {
  if (!files.length) return { count: 0, folderTitle: "" };
  let session = sessions[0];
  if (!session) {
    session = await createProjectFotoSession(orderId, "Fotos");
  }
  for (const file of files) {
    await uploadProjectFotoFile(orderId, session.id, file);
  }
  return { count: files.length, folderTitle: session.title || "Projektfotos" };
}

export function projectFotoUploadErrorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof Error && err.message) return err.message;
  return "Fotos konnten nicht hochgeladen werden.";
}
